/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TankaMasterDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string;
    /**
     * 単価指定区分１コード：数字
     */
    tankaSiteiDiv1?: string;
    /**
     * 単価指定区分２コード：数字
     */
    tankaSiteiDiv2?: string;
    /**
     * 単価指定区分３：数字
     */
    tankaSiteiDiv3?: string;
    /**
     * 単価指定区分４：数字
     */
    tankaSiteiDiv4?: string;
    /**
     * 単価指定区分５：数字
     */
    tankaSiteiDiv5?: string;
    /**
     * 単価範囲開始値：数字
     */
    tankaRangeStart?: number;
    /**
     * 適用開始日付：日付(yyyyMMdd)
     */
    applyStartDate?: string;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 単価正式名称：全角
     */
    tankaAname?: string;
    /**
     * 単価略称名称：全角
     */
    tankaRyaku?: string;
    /**
     * 単価範囲終了値：数字
     */
    tankaRangeEnd?: number;
    /**
     * 単価：数字
     */
    tanka?: number;
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    unitFracCalc?: string;
    /**
     * 調整単価コード（名称）：数字
     */
    unitFracCalcAname?: string;
    /**
     * 単位：数字
     */
    unit?: number;
    /**
     * 超過単価：数字
     */
    exceedTanka?: number;
    /**
     * 超過単位：数字
     */
    exceedUnit?: number;
}

